module.exports = __webpack_public_path__ + "assets/img/clothing.1717d057.png";